import { css as emotionCss, SerializedStyles } from '@emotion/react';
import { Theme } from '@mui/material';

export const css = <Props extends Record<string, unknown> = NonNullable<unknown>>(
  strings: TemplateStringsArray,
  ...args: (
    | string
    | number
    | SerializedStyles
    | ((
        props: {
          theme: Theme;
        } & Props
      ) => string | number | SerializedStyles)
  )[]
) =>
  ((props: { theme: Theme } & Props): SerializedStyles =>
    emotionCss(
      strings,
      ...args.map((arg) => {
        if (typeof arg === 'function') {
          return arg(props);
        }
        return arg;
      })
    )) as unknown as SerializedStyles;
